module.exports = __webpack_public_path__ + "8f9426c57c2a9e50b7ea6dc0738cab71.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/category_1.png
// module id = ./assets/images/category_1.png
// module chunks = 0